<template>
  <button-base variant="secondary" :test-id="testId" v-bind="{ ...$attrs }">
    <!-- @slot Inner button content -->
    <slot></slot>
  </button-base>
</template>

<script>
import ButtonBase from '@/components/elements/buttons/ButtonBase.vue';
import testable from '@/components/mixins/testable';

/**
 * Button Base with hard-coded "secondary" variant
 * @displayName Secondary Button
 */
export default {
  name: 'SecondaryButton',
  components: {
    ButtonBase
  },
  mixins: [testable]
};
</script>
